import { render, staticRenderFns } from "./CreateProductModal.vue?vue&type=template&id=5b96cdae&scoped=true"
import script from "./CreateProductModal.vue?vue&type=script&lang=js"
export * from "./CreateProductModal.vue?vue&type=script&lang=js"
import style0 from "./CreateProductModal.vue?vue&type=style&index=0&id=5b96cdae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b96cdae",
  null
  
)

export default component.exports